import { memo, useCallback } from 'react';

import { CheckIcon } from '@air/design-icons';

import { type ColorDropdownPickerColor } from './colorDropdownPickerTypes';

export type ColorDropdownPickerOptionProps = {
  color: ColorDropdownPickerColor;
  isSelected: boolean;
  onSelect: (color: ColorDropdownPickerColor) => void;
};

export const ColorDropdownPickerOption = memo(({ color, isSelected, onSelect }: ColorDropdownPickerOptionProps) => {
  const handleSelect = useCallback(() => {
    onSelect(color);
  }, [color, onSelect]);

  return (
    <button
      aria-pressed={isSelected}
      className="flex min-h-8 w-full items-center gap-2 rounded-4 px-2 py-1 text-left ads:text-primary text-12 text-gray-12 hover:ads:bg-subtle hover:bg-gray-3"
      data-color-id={color.id}
      data-testid="COLOR_DROPDOWN_PICKER_OPTION"
      onClick={handleSelect}
      type="button"
    >
      <span
        aria-hidden
        className="size-4 shrink-0 rounded-4 border ads:border-strong border-gray-6"
        style={{ backgroundColor: color.hex }}
      />
      <span className="min-w-0 flex-1 truncate">{color.label}</span>
      <span className="shrink-0 font-mono ads:text-metadata text-10 text-gray-9 uppercase">{color.hex}</span>
      {isSelected && <CheckIcon aria-hidden className="shrink-0 ads:text-icon-primary text-blue-9" size="sm" />}
    </button>
  );
});

ColorDropdownPickerOption.displayName = 'ColorDropdownPickerOption';
